var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M 217.070312 187.519531 L 304.441406 123.253906 L 304.441406 251.78125 Z M 217.070312 187.519531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M 70.597656 123.253906 L 157.964844 187.519531 L 70.597656 251.777344 Z M 70.597656 123.253906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M 82.742188 262.929688 L 171.621094 197.5625 L 187.519531 209.253906 L 203.414062 197.5625 L 292.292969 262.929688 L 82.742188 262.929688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M 82.742188 112.101562 L 292.292969 112.101562 L 187.519531 189.167969 Z M 82.742188 112.101562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M 187.519531 357.308594 C 93.894531 357.308594 17.726562 281.140625 17.726562 187.519531 C 17.726562 93.894531 93.894531 17.726562 187.519531 17.726562 C 281.140625 17.726562 357.308594 93.894531 357.308594 187.519531 C 357.308594 281.140625 281.140625 357.308594 187.519531 357.308594 Z M 187.519531 0 C 83.953125 0 0 83.953125 0 187.519531 C 0 291.082031 83.953125 375.035156 187.519531 375.035156 C 291.082031 375.035156 375.035156 291.082031 375.035156 187.519531 C 375.035156 83.953125 291.082031 0 187.519531 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLogo);
export default __webpack_public_path__ + "static/media/MailLogo.57eeb319b27ab77099457f1b3bca042a.svg";
export { ForwardRef as ReactComponent };